import React, { useState, useEffect } from "react";
import {
  EventsIcon,
  GroupIcon,
  OrganizationIcon,
} from "../../assets/icons/icon-assets";
import {
  Box,
  HStack,
  Pressable,
  Stack,
  ScrollView,
  VStack,
  Text,
} from "native-base";
import { Loc } from "../../App/Loc";
import { Dimensions } from "react-native";
import { useNavigate } from "react-router-dom";
import Attendance from "./Attendance";

function LeftContent(props: any) {
  const navigate = useNavigate();
  const dimensions = Dimensions.get("window");
  const [isAttending, setIsAttending] = useState(false);

  useEffect(() => {
    if (
      props?.passEntity?.type === "LeagueGameBase" ||
      props?.leagueGameEntity?.status === "Started"
    ) {
      setIsAttending(true);
    } else {
      setIsAttending(false);
    }
  }, [props?.passEntity, props?.leagueGameEntity]);

  return (
    <>
      <Stack
        background={"white"}
        shadow="1"
        borderRadius={"8"}
        overflow={"hidden"}
      >
        <VStack space={2} width={"240px"} my={3}>
          {!isAttending ? (
            <>
              <Pressable
                onPress={() => navigate("/my-events")}
                borderRadius={3}
                _hover={{
                  bg: "#EEEEEE",
                }}
              >
                <HStack alignItems={"center"} p={2} space={3} px={5}>
                  <EventsIcon size={30} color="AVColor.primary" />
                  <Text fontSize="lg">{Loc.currentLang.menu.events}</Text>
                </HStack>
              </Pressable>

              <Pressable
                onPress={() =>
                  navigate("/my-teams", { state: { type: "MyTeam" } })
                }
                borderRadius={3}
                _hover={{
                  bg: "#EEEEEE",
                }}
              >
                <HStack alignItems={"center"} p={2} space={3} px={5}>
                  <GroupIcon size={30} color="AVColor.primary" />
                  <Text fontSize="lg">{Loc.currentLang.menu.teams}</Text>
                </HStack>
              </Pressable>

              <Pressable
                onPress={() =>
                  navigate("/my-teams", { state: { type: "Club" } })
                }
                borderRadius={"3"}
                _hover={{
                  bg: "#EEEEEE",
                }}
              >
                <HStack alignItems={"center"} p={2} space={3} px={5}>
                  <OrganizationIcon size={30} color="AVColor.primary" />
                  <Text fontSize="lg">{Loc.currentLang.menu.clubs}</Text>
                </HStack>
              </Pressable>

              <Pressable
                onPress={() =>
                  navigate("/my-teams", { state: { type: "School" } })
                }
                borderRadius={"3"}
                _hover={{
                  bg: "#EEEEEE",
                }}
              >
                <HStack alignItems={"center"} p={2} space={3} px={5}>
                  <OrganizationIcon size={30} color="AVColor.primary" />
                  <Text fontSize="lg">{Loc.currentLang.menu.school}</Text>
                </HStack>
              </Pressable>
            </>
          ) : (
            <Attendance
              view="left"
              passEntity={props?.passEntity}
              leagueGameEntity={props?.leagueGameEntity}
            />
          )}
        </VStack>
      </Stack>
    </>
  );
}

export default LeftContent;
